module.exports = __webpack_public_path__ + "static/gnbfull-676680e5d1ae968183c3a01a1f875d14.mp4";